import React from 'react'
import PropTypes from 'prop-types'
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts'

const PieChartGraph = ({ data, fill }) => {
  // Handle empty or invalid data
  const chartData = Array.isArray(data) ? data : []
  
  if (chartData.length === 0) {
    return (
      <div className="p-2 flex items-center justify-center h-64">
        <span className="text-gray-500">No data available</span>
      </div>
    )
  }
  
  return (
    <div className="p-2"> {/* Reduced outer padding */}
      {/* Pie Chart */}
      <ResponsiveContainer width="100%" height={250}> {/* Adjusted height */}
        <PieChart>
          <Pie data={chartData} cx="50%" cy="50%" fill={fill} dataKey="value" label>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export default PieChartGraph

PieChartGraph.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ),
  fill: PropTypes.string,
}